import Box from '@mui/material/Box';
import { darken, useTheme } from '@mui/material/styles';
import Tooltip from '@mui/material/Tooltip';
import React from 'react';

import { DefaultBadgeProps } from './DefaultBadge.props';

/**
 * A small rounded-square "D" badge marking the default tab. Grey for the plain
 * system default; Amtek green (theme accent — the same green as hyperlinks and
 * filter badges) when a saved default report is the active default. Sits to the
 * left of the tab label.
 */
export const DefaultBadge: React.FC<DefaultBadgeProps> = ({ variant, label = 'Default' }) => {
  const theme = useTheme();
  // Both variants keep the white "D" at ≥4.5:1 contrast: grey[600] for the
  // system variant, and a darkened accent for the report variant (the raw
  // accent is only ~3.7:1 on white, so it's darkened to clear WCAG AA text).
  const bgcolor =
    variant === 'report' ? darken(theme.palette.v4.accent, 0.22) : theme.palette.grey[600];

  return (
    <Tooltip title={label} placement="top" arrow>
      <Box
        component="span"
        role="img"
        aria-label={label}
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 16,
          height: 16,
          borderRadius: '4px',
          bgcolor,
          color: theme.palette.common.white,
          fontSize: '0.625rem',
          fontWeight: 700,
          lineHeight: 1,
          flexShrink: 0,
          userSelect: 'none',
        }}
      >
        D
      </Box>
    </Tooltip>
  );
};
